import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class ProjectBusinessCaseTypeService extends EntityService<IEntity> {
    constructor() {
        super(`/ProjectBusinessCaseTypes`);
    }
}